export const iconFontAwesomeFoodBeverageDrumstickBite = (
	<i className="fa-solid fa-drumstick-bite"></i>
);
